import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { downloadData } from 'aws-amplify/storage';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

import { getAPI } from './util/APIUtils';

import qs from 'query-string';

import './App.css';
import { AppState } from './states/appState';
import { ViewerState } from './states/viewerState';
import { AppActions, OwnProps } from './containers/appContainer';
import { LoadingDialog } from './components/LoadingDialog';
import routes from './routes'

import Fab from '@mui/material/Fab';
import Help from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import NotesIcon from '@mui/icons-material/Notes';
import Typography from '@mui/material/Typography';

// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
// import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

import AuthenticatorFormFields from './AuthenticatorFormFields';
import AuthenticatorComponent from './AuthenticatorComponent';

declare global {
  interface Window {
    downloadForm: (t1: string, t2: string) => void;
    currentQuote: (t1: string) => void;
    openRefAct: (actId: string, revision: string, nodeId: string) => void;
    openLawDoc: (law_act_id: string, law_num: string, law_year: string, law_segment_id: string) => void;
    openLgwanLawDoc: (law_act_id: string, law_segment_id: string) => void;
    detailLink: (URL: string) => void;
  }
};

type AppProps = OwnProps & AppState & AppActions & ViewerState;

const config = process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN' ? {
  Auth: {
    Cognito: {
      // identityPoolId: process.env.REACT_APP_AMPLIFY_AUTH_IDENTITYPOOLID ? process.env.REACT_APP_AMPLIFY_AUTH_IDENTITYPOOLID : '',
      userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLID ? process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLID : '',
      userPoolClientId: process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLWEBCLIENTID ? process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLWEBCLIENTID : '',
      // region: process.env.REACT_APP_AWS_REGION,
      // identityPoolRegion: process.env.REACT_APP_AWS_REGION,
      userPoolEndpoint: process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLENDPOINT ? process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLENDPOINT : '',
    },
  },
  API: {
    REST: {
      //[process.env.REACT_APP_API_1_NAME ? process.env.REACT_APP_API_1_NAME : '']: {
      lcrud: {
        endpoint: process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '',
        region: process.env.REACT_APP_AWS_REGION,
      },
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_STRAGE_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    }
  }
} : {
  Auth: {
    Cognito: {
      identityPoolId: process.env.REACT_APP_AMPLIFY_AUTH_IDENTITYPOOLID ? process.env.REACT_APP_AMPLIFY_AUTH_IDENTITYPOOLID : '',
      userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLID ? process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLID : '',
      userPoolClientId: process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLWEBCLIENTID ? process.env.REACT_APP_AMPLIFY_AUTH_USERPOOLWEBCLIENTID : '',
    },
  },
  API: {
    REST: {
      lcrud: {
        endpoint: process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '',
        region: process.env.REACT_APP_AWS_REGION,
      },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_STRAGE_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    }
  }
};
Amplify.configure(config);

const dict = {
  ja: {
    "Forgot your password?": "パスワードを忘れた場合",
    "Sign in": "サインイン",
    "Back to Sign In": "サインインへ戻る",
    "Send code": "送信",
    "Submit": "送信",
    "Resend Code": "検証コードを再送信",
    "Change Password": "パスワードを設定",
    "Password": "パスワード",
    "Confirm Password": "もう一度入力",
    "Enter your Password": "パスワードを入力",
    "Please confirm your Password": "パスワードをもう一度入力",
    'Incorrect username or password.': "ユーザー名またはパスワードが間違っています。",
    "Your passwords must match": "新しいパスワードと再入力パスワードが一致しません。",
    "Invalid verification code provided, please try again.": "検証コードが間違っています。",
    "Password does not conform to policy: Password not long enough": "パスワードは8文字以上を入力してください。（8文字以上の大文字小文字を含む英・数・記号）\\n 使用できる記号　^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , > < ' : ; | _ ~ ` + =",
    "Password does not conform to policy: Password must have numeric characters": "パスワードは数字を含めてください。（8文字以上の大文字小文字を含む英・数・記号）\\n 使用できる記号　^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , > < ' : ; | _ ~ ` + =",
    "Password does not conform to policy: Password must have uppercase characters": "パスワードは大文字を含めてください。（8文字以上の大文字小文字を含む英・数・記号）\\n 使用できる記号　^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , > < ' : ; | _ ~ ` + =",
    "Password does not conform to policy: Password must have symbol characters": "パスワードは記号を含めてください。（8文字以上の大文字小文字を含む英・数・記号）\\n 使用できる記号　^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , > < ' : ; | _ ~ ` + =",
    "Attempt limit exceeded, please try after some time.": "試行制限を超過しました。しばらくしてからもう一度お試しください",
    "Temporary password has expired and must be reset by an administrator.": "仮パスワードの有効期限が切れています。管理者にご連絡ください。",
    "Request not allowed due to WAF block.": "アクセスが拒否されました。",
  },
};

// 作成した辞書を渡して反映させる
I18n.putVocabularies(dict);
I18n.setLanguage("ja");

const actions = [
  { icon: <NotesIcon color={'secondary'} />, name: '用字用語精査', type: '2' },
  { icon: <NotesIcon color={'secondary'} />, name: '誤字等精査', type: '3' },
  { icon: <NotesIcon color={'secondary'} />, name: '全半角色分け', type: '4' },
  { icon: <NotesIcon color={'secondary'} />, name: '条項ずれ関連', type: '1' },
  { icon: <NotesIcon color={'secondary'} />, name: '見やすく表示', type: '5' },
];

export const App: React.FC<AppProps> = (props) => {
  // 様式ダウンロード
  const getIdid = async () => {
    const session = await fetchAuthSession();
    return session.identityId;
  }
  const getIdidForLGWAN = async () => {
    const user = await getCurrentUser();
    return user.username;
  }

  const downloadFormLGWAN = async (t1: string, t2: string) => {
    const orgFilename = t2.split('/').pop();
    const downloadfilename = (t1 ? t1 + '_' : '様式名なし_') + orgFilename;

    const apiurl = `/tempfile?path=private/${await getIdidForLGWAN()}/${t2}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // const filename = path.split('/').pop();
    link.setAttribute('download', downloadfilename);
    document.body.appendChild(link);
    link.click();
    props.setLoading(false);
  };

  const downloadForm = async (t1: string, t2: string) => {
    try {
      const orgFilename = t2.split('/').pop();
      const downloadfilename = (t1 ? t1 + '_' : '様式名なし_') + orgFilename;
      // const file = await Storage.get(t2, { level: 'private' });
      const downloadTask = await downloadData({
        path: `private/${await getIdid()}/${t2}`,
      });
      const { body } = await downloadTask.result;
      const blob = new Blob([await body.blob()]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      //const filename = path.split('/').pop();
      link.setAttribute('download', downloadfilename);
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      console.log(e);
    }
  };

  // 自例規引用
  const currentQuote = (t1: string) => {
    // 見出しのリンクを取得して対象ノードにジャンプ
    (document.getElementById('a' + t1))?.click();
  };

  // 他例規引用
  const openRefAct = (actId: string, nodeId: string) => {
    const query = `?type=${'revision'}&actId=${actId}&nodeId=${nodeId}&miekesi=false`;
    const url = process.env.REACT_APP_VIEWER_URL ? process.env.REACT_APP_VIEWER_URL.replace('{hostname}', window.location.hostname) : process.env.REACT_APP_VIEWER_URL;
    window.open(url + query, `viewer_${actId}`);
  };

  // 上位法令
  const openLgwanLawDoc = (law_act_id: string, law_segment_id: string) => {
    const baseUrl = process.env.REACT_APP_LGWAN_LAWDOC_URL + `lawdb/law/show/${law_act_id}`;
    const anchor = law_segment_id ? `#${law_segment_id}` : ``;
    const windowName = `law_${law_act_id}`;
    window.open(baseUrl + anchor, windowName);
  };

  const openLawDoc = (law_act_id: string, law_num: string, law_year: string, law_segment_id: string) => {
    // var Lawwin=window.open( "/dummy.html", "lawwin", "width=1012, height=660, top=0, left=0, directories=1, location=1, menubar=1, left=100, top=100, scrollbars=1, status=1, toolbar=1, resizable=1");
    let form = document.createElement('form');
    form.innerHTML = "<input type=\"hidden\" name=\"acttype\" value=\"\"/>"
      + "<input type=\"hidden\" name=\"actyear\" value=\"\"/>"
      + "    <input type=\"hidden\" name=\"actnum\"  value=\"\"/>"
      + "    <input type=\"hidden\" name=\"actseg\"  value=\"\"/>";

    form.target = `winName_${law_act_id}_${law_num}_${law_year}`;
    form.acttype.value = law_act_id;
    form.actyear.value = law_year;
    form.actnum.value = law_num;
    form.actseg.value = law_segment_id;
    form.method = "POST";
    form.action = "https://egovred.legalcrud.com";
    form.encoding = "application/x-www-form-urlencoded";
    document.body.append(form);
    form.submit();
  };
  const detailLink = (URL: string) => {
    window.open(URL, `newWindow`);
  };

  useEffect(() => {
    const query = qs.parse(props.history.location.search);

    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      window.downloadForm = downloadFormLGWAN;
      window.openLgwanLawDoc = openLgwanLawDoc;
    } else {
      window.downloadForm = downloadForm;
      window.openLawDoc = openLawDoc;
    }
    window.currentQuote = currentQuote;
    window.openRefAct = openRefAct;
    window.detailLink = detailLink;

    if ('type' in query) {
      const miekesi = query.miekesi === 'true';
      // リビジョンの表示or編集例規の表示
      if (query.type === 'revision') {
        const highlight = query.highlight ? query.highlight : '';
        const mode = (() => {
          if ((query.mode)) {
            if (!Array.isArray(query.mode)) {
              return query.mode === 'history' ? 'history' : 'current';
            }
          }
          return 'current'
        })();
        props.setLoading(true);
        props.initRevisionViewer('' + query.actId, '' + query.revision, miekesi, '' + highlight, '' + query.nodeId, mode);
      } else if (query.type === 'editor') {
        props.setLoading(true);
        props.initEditingViewer('' + query.actId, '' + query.editingId, '' + query.stepId, miekesi);
      } else if (query.type === 'examination') {
        props.setLoading(true);
        props.initExaminationViewerAsync('' + query.actId, '' + query.editingId, '' + query.stepId, '0', miekesi);
      } else {
        // undef
      }
    } else {
      // undef
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleHelp = () => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      const f = (s) => {
        switch (s) {
          case 'Approver':
          case 'Manager':
            return 'approver';
          case 'Editor':
            return 'editor';
          default:
            return 'viewer';
        }
      };
      const url = process.env.REACT_APP_HELP_URL ? process.env.REACT_APP_HELP_URL.replace('{hostname}', window.location.hostname) : process.env.REACT_APP_HELP_URL;
      const url2 = url ? url.replace('{role}', f(props.role)) : url;
      window.open(url2, `help`);
    } else {
      const f = (s) => {
        switch (s) {
          case 'Approver':
          case 'Manager':
            return '#60533';
          case 'Editor':
            return '#60532';
          default:
            return '#60531';
        }
      };
      const url = process.env.REACT_APP_NEW_HELP_URL ? process.env.REACT_APP_NEW_HELP_URL.replace('{hostname}', window.location.hostname) : process.env.REACT_APP_NEW_HELP_URL;
      const url2 = url ? url.replace('{role}', f(props.role)) : url;
      window.open(url2, `help`);
    }
  };

  const [openm, setOpenm] = React.useState(true);
  const openmDialog = Boolean(openm);
  const handleOpenm = () => {
    setOpenm(true);
  };
  const handleClosem = () => setOpenm(false);
  const handleSelect = (type: string) => { // (e: React.MouseEvent) => 
    handleClosem();
    props.setLoading(true);
    props.setPosNextPrev(-1);
    props.examinationViewerAsync(props.accountid, props.idid, '' + props.actId, '' + props.editingId, '' + props.stepId, type, props.miekesi);
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth'
    });
  };

  const createExamination = () => {
    if (props.type !== 'examination') return '';
    return (
      <Tooltip title="精査メニュー">
        <SpeedDial
          ariaLabel="SpeedDial tooltip"
          sx={{
            position: 'fixed',
            bottom: (theme) => theme.spacing(12),
            right: (theme) => theme.spacing(3),
          }}
          FabProps={{
            sx: {
              bgcolor: 'secondary.main',
              '&:hover': {
                bgcolor: 'secondary.main',
              }
            }
          }}
          icon={<SpeedDialIcon />}
          onClose={handleClosem}
          onOpen={handleOpenm}
          open={openmDialog}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={<Typography color={'secondary'} sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>{action.name}</Typography>}
              //tooltipTitle={<Typography sx={{ paddingLeft: 1, paddingRight: 1, backgroundColor: "grey", color: "white" }}>{action.name}</Typography>}
              tooltipOpen
              onClick={() => handleSelect(action.type)}
            />
          ))}
        </SpeedDial>
      </Tooltip>
    );
  };

  // const createNextPrev = () => {
  //   if (props.type !== 'examination') return '';
  //   return (
  //     <React.Fragment>
  //       <Tooltip title="前のヒット個所">
  //         <Fab color="secondary" aria-label="list" sx={{
  //           position: 'fixed',
  //           zIndex: 2,
  //           bottom: (theme) => theme.spacing(21),
  //           right: (theme) => theme.spacing(3),
  //         }} onClick={handlePrev}>
  //           <KeyboardDoubleArrowUpIcon />
  //         </Fab>
  //       </Tooltip>
  //       <Tooltip title="次のヒット個所">
  //         <Fab color="secondary" aria-label="list" sx={{
  //           position: 'fixed',
  //           zIndex: 2,
  //           bottom: (theme) => theme.spacing(12),
  //           right: (theme) => theme.spacing(3),
  //         }} onClick={handleNext}>
  //           <KeyboardDoubleArrowDownIcon />
  //         </Fab>
  //       </Tooltip>
  //     </React.Fragment>
  //   );
  // }

  // const handlePrev = () => {
  //   const ts = document.getElementsByName('examination');
  //   if (props.posNextPrev > 0) {
  //     const newpos = props.posNextPrev - 1;
  //     const top = ts[newpos].getBoundingClientRect().top + window.scrollY - 70;
  //     window.scrollTo({
  //       left: 0,
  //       top: top,
  //       behavior: 'smooth'
  //     });
  //     props.setPosNextPrev(newpos);
  //   }
  // };
  // const handleNext = () => {
  //   const ts = document.getElementsByName('examination');
  //   if (props.posNextPrev + 1 < ts.length || (ts.length === 1 && props.posNextPrev === -1)) {
  //     const newpos = props.posNextPrev + 1;
  //     const top = ts[newpos].getBoundingClientRect().top + window.scrollY - 70;
  //     window.scrollTo({
  //       left: 0,
  //       top: top,
  //       behavior: 'smooth'
  //     });
  //     props.setPosNextPrev(newpos);
  //   }
  // };

  return (
    <Authenticator formFields={AuthenticatorFormFields} components={AuthenticatorComponent} hideSignUp={true}>
      <BrowserRouter>
        <LoadingDialog loading={props.loading} />
        {createExamination()}
        <Tooltip title="ヘルプ">
          <Fab color="primary" aria-label="list" sx={{
            position: 'fixed',
            zIndex: 2,
            bottom: (theme) => theme.spacing(3),
            right: (theme) => theme.spacing(3),
          }} onClick={handleHelp}>
            <Help />
          </Fab>
        </Tooltip>
        {routes}
      </BrowserRouter>
    </Authenticator>
  );
}

export default App;
